// extracted by mini-css-extract-plugin
module.exports = {"fullBody":"full-body_fullBody__3Zjpg","menuList":"full-body_menuList__26XLt"};